import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import 'antd/dist/antd.css';
import { store } from './redux/store';
import { Routes } from './routes';
import * as serviceWorker from './serviceWorker';
// import "./assets/styles.css";
import './assets/styles.scss';
import './index.css';

console.disableYellowBox = true;

ReactDOM.render(
  <Provider store={store} >
    {/* <React.StrictMode> */}
    <Routes />
    {/* </React.StrictMode> */}
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
